(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-faqs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  // Select all FAQ buttons
  var faqButtons = document.querySelectorAll('.faq-toggle');
  
  // Loop through each FAQ button
  faqButtons.forEach(function(faqButton, index) {
    // Get the associated answer div
    var answerId = faqButton.getAttribute('aria-controls');
    var answer = document.getElementById(answerId);
    var icon = faqButton.querySelector('.faq-icon');
    
    // If it's the first FAQ, open it by default
    if (index === 0) {
      answer.style.display = 'block';
      faqButton.setAttribute('aria-expanded', 'true');
      icon.textContent = '−';  // Change to minus on load
    } else {
      answer.style.display = 'none';
      faqButton.setAttribute('aria-expanded', 'false');
      icon.textContent = '+';  // Keep plus when closed
    }

    // Add click event for toggling FAQ
    faqButton.addEventListener('click', function () {
      var expanded = faqButton.getAttribute('aria-expanded') === 'true';

      // Toggle visibility of the answer
      if (expanded) {
        answer.style.display = 'none';
        faqButton.setAttribute('aria-expanded', 'false');
        icon.textContent = '+';  // Change to plus on close
      } else {
        answer.style.display = 'block';
        faqButton.setAttribute('aria-expanded', 'true');
        icon.textContent = '−';  // Change to minus on open
      }
    });
  });
});


  } catch(e) { console.error(e); }
})();
})();
